import { Compiled, Mixin } from './createTheme.types';

export const getDefaultValue = <T,>(mixin: Compiled<Mixin<T>> | Mixin<T>) => mixin({ theme: {} });
